import * as React from 'react';
import { Component, Props } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import i18next from 'i18next';
import { HomeButtonView } from '../Buttons/HomeButton/HomeButtonView';
import { connect, Dispatch } from 'react-redux';
import { AppState } from '../../reducers';
import {
    clearPromocodeAction,
    getPcrClinicsAction,
    getPromocodesAction
} from '../../actions/Promocodes/promocodes';
import { PCRClinic, Promocode } from '../../models/Promocodes/promocodes';
import TaxiHomeView from './Taxi/TaxiHomeView';
import ErrorView from '../Shared/NotFound/ErrorView';
import Spiner from '../Shared/Spiner/Spiner';
import PcrHomeView from './Pcr/PcrHomeView';
import { checkUserId } from '../../lib/utils';
import * as queryString from 'query-string';
import { setUserIdAction } from '../../actions/user';
import { getProfileInfo } from '../../actions/profile';
import AddressPicker from '../Shared/Address/AddressPicker';

let type: string;
let device: string;

const homeClinicId = 100;
const image = require('../../assets/404_image.png');

interface RouteProps extends RouteComponentProps<{}> {
    match: any;
    history: any;
}

interface PromocodesContainerState {
    preferredClinic: number[];
    clientAddress: string;
    shortClientAddress: string;
    isMap: boolean;
}

interface PromocodesContainerProps extends Props<PromocodesContainer> {
    promocodes: Promocode[] | null;
    loading: boolean;
    error: string;
    userId: string;
    lang: string;
    clinics: Array<PCRClinic>;
}

interface PromocodesContainerDispatch extends Props<PromocodesContainer> {
    setUserId: (userId: string) => any;
    getProfile: (userId: string) => any;
    getPromocodes: (userId: string, preferredClinic?: number[], clientAddress?: string) => any;
    getPCRClinics: (lang: string) => any;
    clearPromocode: () => any;
}

function mapProps(state: AppState, props: PromocodesContainerProps): PromocodesContainerProps {
    return {
        promocodes: state.promocodesState.promocodes,
        loading: state.promocodesState.loading,
        error: state.promocodesState.error,
        userId: state.userState.userId,
        lang: state.userState.lang,
        clinics: state.promocodesState.pcrClinics
    };
}

function mapDispatch(dispatch: Dispatch<any>) {
    return {
        setUserId: (userId: string) => dispatch(setUserIdAction(userId)),
        getProfile: (userId: string) => dispatch(getProfileInfo(userId)),
        getPromocodes: (userId: string, preferredClinic?: number[], clientAddress?: string) => dispatch(getPromocodesAction(type, userId, preferredClinic, clientAddress)),
        getPCRClinics: (lang: string) => dispatch(getPcrClinicsAction(lang)),
        clearPromocode: () => dispatch(clearPromocodeAction()),
    };
}

type AllProps = PromocodesContainerProps & PromocodesContainerState & PromocodesContainerDispatch & RouteProps;

class PromocodesContainer extends Component<AllProps> {
    state = {
        preferredClinic: [],
        clientAddress: '',
        shortClientAddress: '',
        isMap: false
    };

    constructor(props: AllProps) {
        super(props);
        type = (props.match.params as any).type_key;
        device = navigator.userAgent.toLowerCase().includes('iphone') ? 'iphone' : 'android';
    }

    async componentDidMount() {
        const {getPCRClinics, lang, clearPromocode, history} = this.props;
        if (history.location.search) {
            const params = queryString.parse(history.location.search);
            await checkUserId(params.user_id, this.props.userId,
                () => this.props.history.push(`/authorization?channel_id=${localStorage.KON_CHANNEL_ID}&phone=${localStorage.phone}&user_id=${localStorage.channelUserId}&lang=${localStorage.KON_LANG}`),
                await this.props.getProfile, this.props.setUserId);
            document.title = i18next.t(type);
            if (type === 'pcr') {
                getPCRClinics(lang || localStorage.KON_LANG);
            }
            clearPromocode();
        }
    }

    setClinics = (key: number) => {
        const { preferredClinic } = this.state;
        let newPreferredClinic: number[] = preferredClinic;
        const index = newPreferredClinic.indexOf(key);
        if (index !== -1) {
            newPreferredClinic.splice(index, 1);
        } else if (newPreferredClinic.indexOf(homeClinicId) === -1) {
            if (key === homeClinicId) {
                newPreferredClinic = [homeClinicId];
                setTimeout(() => window.scrollTo(0, window.innerHeight), 200);
            } else {
                newPreferredClinic.push(key);
            }
        }
        this.setState({preferredClinic: newPreferredClinic});
    }

    render() {
        const { history, error, userId, promocodes, loading, lang, getPromocodes, clinics } = this.props;
        const { preferredClinic, clientAddress, shortClientAddress, isMap } = this.state;
        return (
            <div className='container'>
                <HomeButtonView
                    clickHome={() => history.push(`/services?user_id=${encodeURIComponent(localStorage.KON_USER_ID)}&channel_id=${localStorage.KON_CHANNEL_ID}&lang=${localStorage.KON_LANG}&tariff_id=${localStorage.KON_TARIFF_ID}`)}
                    fixed={true}
                />
                {error
                    ? <ErrorView
                        image={image}
                        text={error === '404' ? i18next.t('no_codes_available') : i18next.t('sorry_everything_will_work_soon')}
                    />
                    : loading
                        ? <Spiner color={'#0084FF'}/>
                        : type === 'taxi'
                            ? <TaxiHomeView
                                promocodes={promocodes}
                                error={error}
                                getPromocodes={() => getPromocodes(userId || localStorage.KON_USER_ID)}
                                lang={lang || localStorage.KON_LANG}
                                device={device}
                            />
                            : isMap
                                ? <AddressPicker
                                    lang={lang || localStorage.KON_LANG}
                                    address={clientAddress}
                                    onChange={(addr) => {
                                        this.setState({
                                            clientAddress: addr,
                                            shortClientAddress: addr,
                                            isMap: false
                                        });
                                        setTimeout(() => window.scrollTo(0, window.innerHeight), 100);
                                    }}
                                /> :
                                <PcrHomeView
                                    promocodes={promocodes}
                                    error={error}
                                    getPromocodes={() => getPromocodes(userId || localStorage.KON_USER_ID, preferredClinic, clientAddress)}
                                    lang={lang || localStorage.KON_LANG}
                                    clinics={clinics}
                                    preferredClinic={preferredClinic}
                                    fullAddress={clientAddress}
                                    shortAddress={shortClientAddress}
                                    isHomeClinic={(preferredClinic as any).indexOf(homeClinicId) !== -1}
                                    setClinics={(key) => this.setClinics(key)}
                                    setIsMap={(value) => this.setState({isMap: value})}
                                    setShortAddress={(address) => this.setState({shortClientAddress: address})}
                                    setFullAddress={(address) => this.setState({clientAddress: address})}
                                />}
            </div>
        );
    }
}

export default withRouter(connect(mapProps, mapDispatch)(PromocodesContainer));



// WEBPACK FOOTER //
// ./src/components/Promocodes/PromocodesContainer.tsx